import { ConnectionsTable } from "@/features/ConnectionsTable";
import { useConnectionsTable } from "@/features/ConnectionsTable/lib";
import { DeleteConnectionsButton } from "@/pages/ContactsPage/Tabs/ConnectionsTab/Components/DeleteConnectionsButton";
import { EditConnectionsButton } from "@/pages/ContactsPage/Tabs/ConnectionsTab/Components/EditConnectionsButton";
import { ConnectionsTabMobile } from "@/pages/ContactsPage/Tabs/ConnectionsTab/mobile";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import styles from "./styles.module.scss";

export const ConnectionTabContent = () => {
  // TODO: remove this after refactor connections table
  const { state, methods } = useConnectionsTable();

  const { openEditModal, openDeleteModal } = methods;
  const { selectedIds } = state;

  return (
    <ResponsiveBlockSwitcher
      desktop={
        <>
          <div className={styles["control-buttons"]}>
            <EditConnectionsButton
              onClick={openEditModal}
              disabled={selectedIds.length > 1 || !selectedIds.length}
            />
            <DeleteConnectionsButton onClick={openDeleteModal} disabled={selectedIds.length < 1} />
          </div>
          <ConnectionsTable />
        </>
      }
      mobile={<ConnectionsTabMobile />}
    />
  );
};
